export function ClockAddIcon(props: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none' {...props}>
      <path
        d='M12.6673 10.0007V12.334M12.6673 14.6673V12.334M14.6344 8.66732C14.6562 8.44805 14.6673 8.22565 14.6673 8.00065C14.6673 4.31875 11.6826 1.33398 8.00065 1.33398C4.31875 1.33398 1.33398 4.31875 1.33398 8.00065C1.33398 11.6826 4.31875 14.6673 8.00065 14.6673C8.11243 14.6673 8.22356 14.6646 8.33398 14.6591C8.44584 14.6536 8.55698 14.6454 8.66732 14.6344M8.00065 4.00065V8.00065L10.4929 9.24678M12.6673 12.334H15.0007H10.334'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
